import {
    simOnlyOldDataAllowance,
    simOnlyOldMonthlyCost,
    SimOnlyPlan,
    simOnlyPlanDataLimit, simOnlyPlanDataRoaming, simOnlyPlanMonthlyCost
} from "../../../Model/Sales/SimOnlyPlan";
import {CmsContent} from "../../../Model/CmsContent/CmsContent";
import {optHtmlContent, renderDynamicContent} from "../../../Utilities/CmsUtilities";
import {KeyValue} from "../../../Types/KeyValue";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {ApplicationContext} from "../../../ApplicationContext";

interface SimCardInfoSoloProps {
    readonly cmsContent: CmsContent[];
    readonly simOnlyPlan: SimOnlyPlan;
    readonly planHexColor: string;
}

const SimCardInfoSolo = (props: SimCardInfoSoloProps): JSX.Element | null => {

    const [expanded, setExpanded] = React.useState<boolean>(false)
    const toggleRef = React.useRef<HTMLButtonElement>(null);

    const plan = props.simOnlyPlan

    const optSoloSimInfoCard = optHtmlContent(props.cmsContent, "sp-card-sim-info-solo")
    const optSoloSimInfoCardExpanded = optHtmlContent(props.cmsContent, "sp-card-sim-info-solo-expanded")

    if (optSoloSimInfoCard && optSoloSimInfoCardExpanded) {
        const dataAllowanceElement = plan.promoAddonLimit != null ? (
            <div>
                <s>{simOnlyOldDataAllowance(plan)}</s> <span>{simOnlyPlanDataLimit(plan)}</span>
            </div>
        ) : (
            <span>{simOnlyPlanDataLimit(plan)}</span>
        );
        const planPriceElement = plan.promoDiscount ? (
            <div>
                <s>£{simOnlyOldMonthlyCost(plan)}</s> <span>£{simOnlyPlanMonthlyCost(plan)}</span>
            </div>
        ) : (
            <span>£{simOnlyPlanMonthlyCost(plan)}</span>
        );

        const templateTags: KeyValue<string | React.ReactNode | React.ReactNode[]>[] = [
            {key: "DATA_ALLOWANCE", value: dataAllowanceElement},
            {key: "PLAN_DESCRIPTION", value: plan.description},
            {key: "PLAN_PRICE", value: planPriceElement},
            {key: "PLAN_COLOUR", value: props.planHexColor},
            {key: "MONTHLY_PRICE", value: `${simOnlyPlanMonthlyCost(plan)}`},
            {key: "ROAMING_DATA", value: simOnlyPlanDataRoaming(plan)}
        ]


        let template;

        if (expanded) {
            template = optSoloSimInfoCardExpanded
        } else {
            template = optSoloSimInfoCard
        }


        const simInfoContent = renderDynamicContent(template, templateTags);

        return (
            <>
                <style>
                    {`
                    .sim-info-toggle-btn {
                        width: 100%;
                        border: none;
                        background: transparent;
                        cursor: pointer;
                        text-align: center;
                        font-weight: 600;
                        margin-top: -12px;
                    }
                    
                    .sim-info-rounded-solo {
                        margin-bottom: -25px;
                        border-top-left-radius: 15px;
                        border-top-right-radius: 15px;
                        border-bottom-right-radius: 15px;
                        border-bottom-left-radius: 15px;
                        padding-bottom: 0rem !important;
                        background: ${props.planHexColor};
                    }
                    
                    .sp-card-hollow
                    
                    .sim-info-splitter {
                        width: 95%;
                        background-image: initial;
                        background-position-x: initial;
                        background-position-y: initial;
                        background-size: initial;
                        background-repeat: initial;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                        background-color: rgb(255, 255, 255);
                        margin-right: auto;
                        margin-bottom: 0.5rem;
                        margin-left: auto;
                        margin-top: -15px;
                    }
                `}
                </style>
                <div
                    style={{cursor: "pointer"}}
                    className={`d-flex flex-column sim-info-rounded-solo`}
                >
                    {simInfoContent}
                    {!expanded && <button
                        ref={toggleRef}
                        type="button"
                        className="sim-info-toggle-btn"
                        onClick={() => setExpanded(true)}
                    >
                        View details ▼
                    </button>}
                    {expanded && (

                            <button
                                type="button"
                                ref={toggleRef}
                                className="sim-info-toggle-btn"
                                onClick={() => setExpanded(false)}
                            >
                                Hide details ▲
                            </button>

                    )}

                </div>
            </>
        )
    } else {
        return null
    }
}

export default SimCardInfoSolo